import React, { useState } from 'react';
import { ReactComponent as Logo } from 'assets/svg/logo.svg';
import Input from 'components/Input';
import RoundedButton from 'components/RoundedButtons';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { emailSubscribe } from 'reduxStore/actions/emailSubscription';
import { toast } from 'react-toastify';
import { setDialogState } from 'reduxStore/reducers/dialogSlice';
import { isLoggedIn } from 'utils/helpers';
import LogoImg from 'assets/image/LOGO - Icon.png';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { email_error, emailRegExp } from 'pages/Login/constants/text';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";


const Footer = () => {
 

const location = useLocation();
  const dispatch = useDispatch();
  const { dialogOpenState } = useSelector((state) => state.dialogOpenState);

  const navLinks = {
    pregaCenter: {
      title: 'Prega Center',
      navOptions: [
        {
          title: 'Blogs',
          link: '/blogs',
        },
        {
          title: 'Pregnancy',
          link: '/pregnancy',
        },
        {
          title: 'Baby',
          link: '/baby',
        },
        {
          title: 'Parenthood',
          link: '/parenthood',
        },
        {
          title: 'Family',
          link: '/family',
        },
        {
          title: 'Community',
          link: '/community',
        },
        // {
        //   title: 'Courses',
        //   link: '/courses',
        // },
      ],
    },
    resources: {
      title: 'Resources',
      navOptions: [
        {
          title: 'Mobile App',
          link: '/mobileapp',
        },
        {
          title: 'About Us',
          link: '/aboutus',
        },

        {
          title: 'Contact us',
          link: '/contactus',
        },

        {
          title: 'Privacy Policy',
          link: '/privacypolicy',
        },
        {
          title: 'Terms of Use',
          link: '/termsofuse',
        },
      ],
    },
    connect: {
      title: 'Connect',
      navOptions: [
        {
          title: 'Instagram',
          link: 'https://www.instagram.com/pregacenter/',
        },
        {
          title: 'YouTube',
          link: 'https://www.youtube.com/channel/UCyJ3u9o7365q55896-6433',
        },
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/pregacenter/',
        },
        {
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/pregacenter/',
        },
        {
          title: 'Twitter',
          link: 'https://twitter.com/pregacenter',
        },
      ],
    },
  };

  const formik = useFormik({
    initialValues:{
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
      .transform((value) => (value.trim() === '' ? '' : value.trim()))
      .required(email_error.require_email)
      .min(10, 'Email must be at least 10 characters long')
      .max(30, 'Email must be less than 30 characters long')
      .matches(emailRegExp, email_error.valid_email)
      .matches(
        /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
        'Email cannot contain capital letters'
      ).matches(
      /^[\w.-]+@[^0-9][\w.-]+\.[a-zA-Z]{2,}$/,
      "Email cannot have a number after @"
    )
    }),
    onSubmit: (values) => {
      handleEmailSubscription(values.email);
    },
  })
  
  const handleEmailSubscription = async (email) => {
    
    if (!email) {
      toast.error('Please enter an email address');
      return;
    }
    try {
      const response = await  dispatch(emailSubscribe({ email })).unwrap()
      if (response?.success) {
        toast.success(response?.message);
        formik.resetForm();
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
      formik.resetForm();
    }
  };

  const handleLinkClick = (e, option) => {
    // Check if it's an external link (starts with http)
    if (option.link.startsWith('http')) {
      return; // Allow normal navigation for external links
    }

    // Protected routes that require login
    const protectedRoutes = [ '/community', '/courses'];
    
    if (protectedRoutes.includes(option.link)) {
      // If user is not logged in, show login modal and prevent navigation
      if (!isLoggedIn()) {
        e.preventDefault();
        dispatch(
          setDialogState({
            ...dialogOpenState,
            logIn: true,
            register: false,
          })
        );
      }
    }
    // For all other routes, allow normal navigation
  };



useEffect(() => {
  formik.resetForm();
}, [location.pathname]);

  return (
    <footer className='w-full flex flex-col mt-8 px-[15px] gap-12 xl:gap-16 2xl:gap-24  py-8 sm:pt-16 sm:pb-[42px] rounded-[28px] sm:rounded-card-rounded bg-[#1A0E12] md:px-10 sm:px-[15px]'>
      <div className='container flex flex-col xl:flex-row justify-between gap-8 xl:gap-52'>
        <div className='flex flex-col justify-center max-w-[480px] flex-shrink-0 gap-8'>
          <div className='flex flex-col gap-3'>
          <img src={LogoImg} alt='Prega Center logo' className='w-[72px] h-[72px]' />

            <h1 className='text-[#9D8F93]'>
              Join our community, access vital tools, and receive tailored
              guidance for every stage of your journey
            </h1>
          </div>
          {/* Newsletter */}
          <div className='w-full flex flex-col gap-1'>
          <div className='relative flex flex-col sm:block gap-3 sm:gap-0 max-w-[90%]'>
          <div className='w-full flex flex-col gap-1'>
            <Input
              placeholder='Email Address'
              labelText='Newsletter'
              value={formik.values.email}
              onChange={formik.handleChange}
              inputClassName='sm:pr-[150px]'
              labelClassName='text-white'
              name='email'
              onBlur={formik.handleBlur}
            />
           {formik.touched.email && formik.errors.email && (
            <div className="text-red text-sm pl-1 sm:hidden">
                {formik.errors.email}
              </div>
            )}
           
            </div>
            <RoundedButton
              onClick={formik.handleSubmit}
              text='Subscribe'
              className='sm:absolute h-[46px] sm:h-12 md:h-[50px] xl:h-[52px] self-center sm:self-auto bottom-0 right-0 text-base '
            />
          
          </div>
          {formik.touched.email && formik.errors.email && (
              <div className='text-red text-sm pt-1 pl-1 sm:block hidden'>{formik.errors.email}</div>
            )}
            </div>
        </div>
        <div className='flex flex-row flex-wrap gap-8 w-[100%] justify-between'>
          <div className='flex flex-col gap-4 '>
            <h2 className='text-white text-[18px] md:text-[20px] font-semibold'>
              {navLinks.pregaCenter.title}
            </h2>
            <div className='flex flex-col gap-2'>
              {navLinks.pregaCenter.navOptions.map((option, index) => (
                <Link 
                  to={option.link} 
                  key={index}
                  onClick={(e) => handleLinkClick(e, option)}
                >
                  <div
                    key={index + 'pregacenter'}
                    className=' text-[#9D8F93] hover:text-primary text-[16px] md:text-[18px]'
                  >
                    {option.title}
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className='flex flex-col gap-4'>
            <h2 className=' text-white text-[18px] md:text-[20px] font-semibold'>
              {navLinks.resources.title}
            </h2>
            <div className='flex flex-col gap-2'>
              {navLinks.resources.navOptions.map((option, index) => (
                <Link 
                  to={option.link} 
                  key={index}
                  onClick={(e) => handleLinkClick(e, option)}
                >
                  <div
                    key={index + 'resources'}
                    className='text-[#9D8F93] hover:text-primary text-[16px] md:text-[18px]'
                  >
                    {option.title}
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className='flex flex-col gap-4'>
            <h2 className=' text-white text-[18px] md:text-[20px] font-semibold'>
              {navLinks.connect.title}
            </h2>
            <div className='flex flex-col gap-2'>
              {navLinks.connect.navOptions.map((option, index) => (
                <Link 
                  to={option.link} 
                  key={index}
                  onClick={(e) => handleLinkClick(e, option)}
                >
                  <div
                    key={index + 'connect'}
                    className=' text-[#9D8F93] hover:text-primary text-[16px] md:text-[18px]'
                  >
                    {option.title}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <h1 className='text-[#816F74] text-center text-[16px] text-wrap container'>
        Copyright © {new Date().getFullYear()} PregaCenter. All Rights Reserved
      </h1>
    </footer>
  );
};

export default Footer;
